/*
 * @Description: main.js
 * @Date: 2022-11-30 15:08:18
 * @Author: mazexin
 * @LastEditors: mazexin
 */

import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import {
  // BrowserRouter as Router
  HashRouter as Router
} from 'react-router-dom'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import store from './stores'
import 'moment/locale/zh-cn'
import { changeLanguage } from './i18n/config'
import './plugin/monitor'
import VConsole from 'vconsole'
import { getQueryString, isMobile } from '@/utils'
import '@/i18n/config'
// import i18n from 'i18next'
import '@/plugin/flexible'
import GlobalStyle from '@/components/GlobalStyle' // 动态加载全局样式
import ConfigProvider from '@/components/ConfigProvider' // 动态组件库多语言

if (
  (/^(dev|local)/.test(process.env.REACT_APP_KZ_ENV) ||
    getQueryString('test') === 'kz') &&
  isMobile()
) {
  // new VConsole()
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <>
    <GlobalStyle />
    {/* // <React.StrictMode> */}
    <Provider store={store}>
      <ConfigProvider>
        <Router>
          <Suspense fallback={null}>
            <App />
          </Suspense>
        </Router>
      </ConfigProvider>
    </Provider>

    {/* // </React.StrictMode> */}
  </>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
